export default "/_next/static/images/9a87fe28fcfbb3ac49f7406aa3bfa0f6.png";